import customAxios from "../../customHook/customAxios";

import { getAuthHeader } from '../../utils';

export const v3_add_expense_entry = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/expense/application`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_edit_expense_entry = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/expense/application`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_submitted_expenses = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/expense/submitted/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_get_expense_exchange_rates = async (refresh = false) => {
    const queryString = refresh ? '?refresh=1' : '';
    const url = `${process.env.REACT_APP_BASE_URL}/v3/expense/exchange-rates${queryString}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}
